const {LitElement, html, repeat, ref, nothing, createRef} = window.globalLit;

customElements.define('browser-steps', class E2eStepsElement extends LitElement {
    static properties = {
        steps: { type: Array },
        readonly: { type: Boolean, attribute: 'readonly' }
    };

    popupRef = createRef();
    editStepRef = createRef();
    buttonRef = createRef();
    popperInstance = null;

    createRenderRoot() { return this; }

    constructor() {
        super();
        this.readonly = false;
    }

    connectedCallback() {
        super.connectedCallback();

        document.addEventListener('click', event => {
            if (this.buttonRef.value) {
                let isButtonOrPopup = this.buttonRef.value.contains(event.target) || this.popupRef.value.contains(event.target);
                if (!isButtonOrPopup) {
                    this.popupRef.value.style.display = 'none';
                }
            }
        });
   
        this.addEventListener('stepchange', (event) => {
            let step = event.detail;

            let index = this.steps.findIndex(s => {
                return s.id === step.id;
            });

            if (index === -1) {
                console.error('Could not find step', step);
                return;
            }

            this.steps[index] = step;
            this.requestUpdate();

            this._dispatchChangeEvent();
        });
        
        let parentForm = this.closest('form');
        parentForm && parentForm.addEventListener('submit', event => {
            this.insertAdjacentHTML('beforeend', `<input type="hidden" name="steps" value='${JSON.stringify(this.steps)}'>`);
        });
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.popperInstance.destroy();
    }

    firstUpdated() {
        this.popperInstance = Popper.createPopper(
            this.buttonRef.value,
            this.popupRef.value
        );
    }

    _onAddClick() {
        if (this.readonly) { return; }

        if (this.popupRef.value.checkVisibility()) {
            this.popupRef.value.style.display = 'none';
        } else {
            this.popupRef.value.style.display = '';
        }

        this.popperInstance.update();
    }

    _onDeleteClick(id) {
        if (this.readonly) { return; }

        let newSteps = this.steps.filter(s => {
            return s.id !== id;
        });

        this.steps = newSteps;

        this._dispatchChangeEvent();
    }

    _onDuplicateClick(id) {
        if (this.readonly) { return; }

        let step = this.steps.find(s => { return s.id === id });

        let newStep = Object.assign({}, step);

        newStep.id = createStepId();

        this.addStep(newStep);
    }

    _onEditClick(id) {
        if (this.readonly) { return; }

        let step = this.steps.find(s => { return s.id === id });

        let editStep = this.editStepRef.value;
        editStep.step = step;

        editStep.open();

        // let newStep = Object.assign({}, step);

        // newStep.id = createStepId();

        // this.addStep(newStep);
    }

    addStep(step, event) {
        if (this.readonly) {
            return;
        }
        step.id = createStepId();
        this.steps.push(step);
        this.popupRef.value.style.display = 'none';
        this.requestUpdate();

        this._dispatchChangeEvent();
    }

    _dispatchChangeEvent() {
        this.dispatchEvent(new CustomEvent('change', {
            detail: this.steps,
            bubbles: true
        }));
    }

    _onDragStart(step, event) {
        if (this.readonly) {
            event.preventDefault();
            return;
        }
        event.dataTransfer.setData('stepId', step.id);
    }

    _onDrop(event) {
        if (this.readonly) {
            return;
        }
        let stepId = event.dataTransfer.getData('stepId');

        let container = event.target.closest('.steps__container');

        let stepIndex = [...container.querySelectorAll('.step')].findIndex(stepNode => {
            let bounds = stepNode.getBoundingClientRect();
            let stepNodeY = bounds.top + bounds.height;
            return stepNodeY > event.clientY;
        });

        if (stepIndex === -1) {
            return;
        }

        if (stepIndex === 0) { // El primer paso no se puede mover
            return;
        }

        this._reorder(stepId, stepIndex);

    }

    _reorder(stepId, stepIndex) {

        let step = this.steps.find(s => {
            return s.id === stepId;
        });

        let newSteps = this.steps.filter(s => {
            return s.id !== stepId;
        });

        newSteps.splice(stepIndex, 0, step);

        this.steps = newSteps;
    }

    _onDragOver(event) {
        event.preventDefault();
    }

    unhighlightSteps() {
        let newSteps = this.steps.map(s => {
            s.highlight = false;
            return s;
        });
        this.steps = newSteps;
    }

    highlightStep(step) {
        let newSteps = this.steps.map(s => {
            if (s.id === step.id) {
                s = Object.assign({}, s, step);
                s.highlight = s.error ? 'error' : 'success';
            } else {
                s.highlight = false;
            }
            return s;
        });

        this.steps = newSteps;

    }

    highlightStepAfterTime(time) {
        // Highlight (add property "highlight" = true) the step if the step.startTime is less than the time parameter. Only a single step should be highlighted at a time.
        let newSteps = this.steps.map(s => {
            if (s.startTime < time) {
                s.highlight = s.error ? 'error' : 'success';
            } else {
                s.highlight = false;
            }
            return s;
        });

        this.steps = newSteps;
        // this.requestUpdate();
    }

    render() {
        return html`
            <div>
                <div class="steps__container" @drop=${this._onDrop} @dragover=${this._onDragOver}>
                    ${this.steps.length === 0 ? 
                        html`<div class="nodata mb-3">No steps added yet. ${this.readonly ? '' : 'Click on the button below or interact with the browser to the right to start.'}</div>` :
                        repeat(
                            this.steps,
                            step => step.id,
                            (step, index) => {
                                let innerHtml = '';

                                let isFirst = index === 0;

                                if (step.command === 'goto') {
                                    innerHtml = html`<navigate-step .value=${step} .readonly=${this.readonly}></navigate-step>`;
                                    
                                } else if (step.command === 'expect') {
                                    innerHtml = html`<expect-step .value=${step} .readonly=${this.readonly}></expect-step>`;

                                } else if (step.command === 'click') {
                                    innerHtml = html`<click-step .value=${step} .readonly=${this.readonly}></click-step>`;

                                } else if (step.command === 'waitForTimeout') {
                                    innerHtml = html`<wait-step .value=${step} .readonly=${this.readonly}></wait-step>`;

                                } else if (step.command === 'fill') {
                                    innerHtml = html`<fill-step .value=${step} .readonly=${this.readonly}></fill-step>`;

                                } else if (step.command === 'check') {
                                    innerHtml = html`<check-step .value=${step} .readonly=${this.readonly}></check-step>`;

                                } else if (step.command === 'type') {
                                    innerHtml = html`<type-step .value=${step} .readonly=${this.readonly}></type-step>`;

                                } else {
                                    console.error('Unknown command: ' + step.command);
                                    return html(`<div class="step text-danger">Unknown command: ${step.command}</div>`);
                                }

                                let extraClassName = '';
                                if (step.highlight === 'success') {
                                    extraClassName += ' step--success';
                                } else if (step.highlight === 'error') {
                                    extraClassName += ' step--error';
                                } else if (!step.enabled) {
                                    extraClassName += ' step--disabled';
                                }

                                return html`
                                    <div class="step ${extraClassName}">
                                        ${(() => {
                                            if (this.readonly || isFirst) { return nothing; }
                                            return html`
                                                <a href="" class="step__move" draggable="true" @dragstart=${this._onDragStart.bind(this, step)} style="text-decoration: none;">
                                                    <i class="fa-solid fa-grip-vertical"></i>
                                                </a>
                                                `
                                        })()}

                                        <div class="step__content">
                                            ${innerHtml}
                                        </div>

                                        ${(() => {

                                            if (this.readonly) { return nothing; }

                                            return html`
                                                <sl-dropdown class="step__actions">
                                                    <button slot="trigger" class="btn btn-default btn-xs" type="button">
                                                        <i class="fa fa-grip"></i>
                                                    </button>
                                                    
                                                    <sl-menu>
                                                        <sl-menu-item @click=${this._onEditClick.bind(this, step.id)}>  
                                                            Edit
                                                        </sl-menu-item>
                                                        <sl-menu-item @click=${this._onDuplicateClick.bind(this, step.id)}>  
                                                            Duplicate
                                                        </sl-menu-item>

                                                        ${(() => {
                                                            if (isFirst) { return nothing; }
                                                            return html`
                                                                <sl-menu-item @click=${this._onDeleteClick.bind(this, step.id)}>  
                                                                    <span class="text-danger">Delete</span>
                                                                </sl-menu-item>
                                                                `
                                                        })()}
                                                        
                                                        
                                                    </sl-menu>
                                                </sl-dropdown>
                                            `
                                        })()}

                                        
                                    </div>
                                `;
                            }
                        )
                    }
                </div>
                ${this.readonly ? '' : html`
                    <div class="steps__actions text-center">
                        <button type="button" class="btn btn-outline-secondary btn-xs" ${ref(this.buttonRef)} @click=${this._onAddClick}>+</button>
                    </div>
                `}
            </div>
                
            <div ${ref(this.popupRef)} role="tooltip" style="display:none; width: 200px; z-index: 2;">
                <div class="card shadow">
                    <div class="card-body p-2">
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command:'goto'})}>
                            Navigate to
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command:'expect', what: 'toHaveTitle'})}>
                            Expect page to have title
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command:'expect', what: 'toBeInViewport', element: {locator:'css'}})}>
                            Expect element to be inside viewport
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command:'expect', what: 'toBeVisible', element: {locator:'css'}})}>
                            Expect element to be visible
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command:'expect', what: 'content', element: {locator:'css'}})}>
                            Expect element content...
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command: 'click', element: {locator:'css'}})}>
                            Click
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command: 'waitForTimeout'})}>
                            Wait
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command:'fill', element: {locator:'css'}})}>
                            Fill field
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command:'check', element: {locator:'css'}})}>
                            Check field
                        </a>
                        <a href="javascript:void(0);" class="btn btn-light btn-sm" style="display:block;" 
                            @click=${this.addStep.bind(this, {command:'type', text: ''})}>
                            Type text
                        </a>
                    </div>
                </div>
            </div>

            <edit-step ${ref(this.editStepRef)}></edit-step>

        `;
    }
});

function createStepId() {
    return Math.random().toString(36).substring(2, 10);
}